import { motion, useAnimate } from "framer-motion";
// import iconImg from "@assets/images/list-item-icon.avif";
import { useEffect, useRef } from "react";

function BoxLayout({ index, icon, heading, text, colorScheme,iconImg }) {
  const [motionRef, animate] = useAnimate(); 

  useEffect(() => {
    const motionElement = motionRef.current;

    const motionAnimation = animate(
      motionElement,
      { backgroundColor: ["#F3EBFA", "#DEC9F6"] },
      {
        duration: 2,
        repeat: Infinity,
        repeatType: "reverse",
        ease: "linear",
      }
    );

    // console.log(motionAnimation);

    return () => {
      motionAnimation.cancel();
    };
  }, []);
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} // appears from bottom
      whileInView={{ opacity: 1, y: 0 }} // visible on scroll
      transition={{ duration: 0.3, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.2 }} 
      key={index}
      className="transition-all duration-300 ease-in hover:bg[#FFC067] cursor-pointer drop-shadow-xl h-full   rounded-lg  items-center overflow-hidden  w-full md:w-[calc(49%-0.67rem)] xl:w-[calc(32%-0.67rem)] "
    >
      <div 
        ref={motionRef}
        className={`flex justify-start  ${icon ? 'items-center':'items-center'} space-x-3 py-5 md:py-0   md:min-h-20 lg:min-h-20  px-5  `}
      >
        <div className={`w-auto h-full flex ${icon ? 'justify-center items-center ' : 'justify-center  items-center   md:pt5'}  space-x-2 `}>
          {icon ? (
            <img src={icon} alt={heading} className="w-11 " width={10} height={10}/>
          ) : (
            <img src={iconImg} alt='List icon' className="w-10 h-10 object-contain " width={10} height={10}/>
          )}
        <motion.h3
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true, amount: 0.3 }}
          className="md:text-lg font-bold text-dark  whitespace-pre-line"
        >
          {heading}
        </motion.h3>
          </div>
      </div>
      <div className="px-5 py-5 bg-white ">
        <p className="text-base leading-[1.625rem] text-dark">{text}</p>
      </div>
    </motion.div>
  );
}

export default BoxLayout;
